import React from 'react'
import { FieldsGrid } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import { EscalationReasonFields } from './EscalationReasonFields'
import { PaymentEvidenceFields } from './PaymentEvidenceFields'
import { TicketField } from './TicketField'
import { PAID_ESCALATION_REASON_OPTIONS } from '../statusUpdate.type'

interface PaidEscalationFieldsProps {
  primaryPaymentMethod?: string
}

export function PaidEscalationFields({
  primaryPaymentMethod,
}: PaidEscalationFieldsProps) {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <TicketField />
        <PaymentEvidenceFields primaryPaymentMethod={primaryPaymentMethod} />
        <EscalationReasonFields reasons={PAID_ESCALATION_REASON_OPTIONS} />
      </FieldsGrid>
    </div>
  )
}
